import React, { Component } from 'react';
import PropTypes from 'prop-types';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { equals, pathOr } from 'ramda';

import Slider from './vendors/react-slick';
import { TouchContainer } from './carousel.styles';
import { renderWhenTrue } from '../../utils/rendering';

const defaultOptions = {
  slidesToShow: 1,
  dots: false,
  infinite: true,
  speed: 500,
  slidesToScroll: 1,
  accessibility: true,
  arrows: false,
};

const getInteractionPosition = e => pathOr(e.clientX, ['touches', 0, 'clientX'], e);

const preventDefault = e => e.preventDefault();

export class Carousel extends Component {
  static propTypes = {
    options: PropTypes.object,
    children: PropTypes.any,
    className: PropTypes.string,
    autoplay: PropTypes.bool,
    arrowPrev: PropTypes.func,
    arrowNext: PropTypes.func,
  };

  static defaultProps = {
    options: {},
  };

  componentDidMount() {
    this.touchContainerRef.current.addEventListener('mousedown', this.handleSwipeStart);
    this.touchContainerRef.current.addEventListener('click', this.handleSwipeEnd);
    this.touchContainerRef.current.addEventListener('mousemove', preventDefault);
    this.touchContainerRef.current.addEventListener('dragstart', preventDefault);
    this.touchContainerRef.current.addEventListener('touchstart', this.handleSwipeStart);
    this.touchContainerRef.current.addEventListener('touchmove', this.handleSwipeEnd, { passive: false });
  }

  shouldComponentUpdate(nextProps) {
    return !equals(this.props, nextProps);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.autoplay !== this.props.autoplay) {
      const method = this.props.autoplay ? 'slickPlay' : 'slickPause';
      this.sliderRef.current[method]();
    }
  }

  componentWillUnmount() {
    this.touchContainerRef.current.removeEventListener('mousedown', this.handleSwipeStart);
    this.touchContainerRef.current.removeEventListener('click', this.handleSwipeEnd);
    this.touchContainerRef.current.removeEventListener('mousemove', preventDefault);
    this.touchContainerRef.current.removeEventListener('dragstart', preventDefault);
    this.touchContainerRef.current.removeEventListener('touchstart', this.handleSwipeStart);
    this.touchContainerRef.current.removeEventListener('touchmove', this.handleSwipeEnd, { passive: false });
  }

  get multipleSlides() {
    return React.Children.count(this.props.children) > 1;
  }

  nextSlide = () => this.sliderRef.current.slickNext();

  sliderRef = React.createRef();
  touchContainerRef = React.createRef();

  handleSwipeStart(e) {
    this.firstClientX = getInteractionPosition(e);
  }

  handleSwipeEnd(e) {
    const minValue = 5;

    const xDiff = getInteractionPosition(e) - this.firstClientX;

    if (Math.abs(xDiff) > minValue) {
      e.preventDefault();
      e.returnValue = false;
      return false;
    }

    return true;
  }

  handlePrevClick = () => this.sliderRef.current.slickPrev();
  handleNextClick = () => this.sliderRef.current.slickNext();

  render() {
    const { options, children, className, autoplay, arrowNext: ArrowNext, arrowPrev: ArrowPrev } = this.props;
    return (
      <TouchContainer ref={this.touchContainerRef}>
        {renderWhenTrue(() => <ArrowPrev onClick={this.handlePrevClick} />)(ArrowPrev && this.multipleSlides)}
        <Slider ref={this.sliderRef} {...defaultOptions} {...options} autoplay={autoplay} className={className}>
          {children}
        </Slider>
        {renderWhenTrue(() => <ArrowNext onClick={this.handleNextClick} />)(ArrowNext && this.multipleSlides)}
      </TouchContainer>
    );
  }
}
